<template>
  <div class="nut-banner banner-formule">
    <div class="container">
      <div class="row">
        <div class="col-lg-7 offset-lg-1 col-md-12">
          <h1 class="banner-formule-title">
            <span style="font-weight: 700">Află cum prepari <br class="d-block d-md-none">
              pregătești sau faci trecerea la<br class="d-block d-md-none">
              Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup>
            </span>
          </h1>
        </div>
        <div class="col-md-4 part-img">
          <img class="img-fluid banner-formule-img banner-formule-img-update" src="../../assets/images/preparare-formule/products.png">
        </div>
      </div>

    </div>
  </div>
</template>

<script>

export default {

  components: {},
  data() {
    return {}
  },
  methods: {
    tricksAptamil() {
      window.gtag('event', 'click', {'event_category': 'sfaturi-preparare'});
    },
    transitionAptamil() {
      window.gtag('event', 'click', {'event_category': 'sfaturi-tranzitie'});
    }
  },
}
</script>

<style scoped lang="scss">
.banner-formule-img-update {
  max-width: 160%;
}
.btn-blue-dark {
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  background: #17479E;
  border-radius: 10px;
  height: 50px;
  width: 100%;

  a {
    color: inherit;
    text-decoration: none;
  }
}

.nut-banner {
  &.banner-formule {
    height: 420px;
    position: relative;
    background-color: #abcae9;

    .banner-formule-title{
      font-size: 40px;
      font-weight: 700;
      line-height: 48px;
    }

    .container {
      position: relative;
      height: inherit;
      .row {
        height: inherit;
        align-items: center;
      }
    }

    .border-white {
      border: 1px solid #fff;
      border-radius: 62%;
    }

    h2 {
      font-size: 24px;
      font-weight: 700;
      color: #17479E;
      margin-left: 30px;

      span {
        font-size: 16px;
        font-weight: 500;
        color: #17479E;
      }
    }

    .link-btn {
      position: relative;
      bottom: 30px;
    }
  }
}

@media only screen and (max-width: 576px) {
  .nut-banner .banner-formule-img {
    max-width: 100%;
    height: auto;
    display: table;
    margin: auto;
  }

  .nut-banner {
    &.banner-formule {
      height: 420px;
      //background-image: url("../../assets/images/preparare-formule/hero.png");
      background-repeat: no-repeat;
      background-position: center bottom;
      background-size: cover;
      h1 {
        text-align: center;
        line-height: 30px !important;
        span{
          font-size: 26px;
          font-weight: 700;
        }
      }

      h2 {
        font-size: 18px;

        span {
          font-size: 14px;
        }
      }

    }
  }
}
</style>
